import React, {Component} from 'react';
import {Col, Form, FormGroup, FormText, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Notify from 'react-notification-alert';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";


class QueryEnvelopeModal extends Component {

	constructor(props) {
		super(props)

		this.notify = React.createRef();

		this.state =
			{
				modal: false,
				envelopeUuid: "",
				result: null,
				code: null,
				processing: false,
				invalidUuid: false,
				invalidMessage: "",
			};

		this.query = this.query.bind(this);
		this.reset = this.reset.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.editHandleInputChange = this.editHandleInputChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.matchesUuid = this.matchesUuid.bind(this);
	}

	componentDidMount() {
		this.setState({
			modal: this.props.modal,
		})
	}

	matchesUuid(uuid) {
		return /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(uuid);
	}

	toggleModal() {
		this.props.toggle();
	}

	reset() {
		this.setState({
			result: null,
			envelopeUuid: "",
			processing: false
		})
	}

	query() {
		let self = this;
		let envelopeUuid = this.state.envelopeUuid;

		if (!envelopeUuid) {
			this.setState({invalidUuid: true, invalidMessage: "Zarf ETTN girmediniz."})
			return;
		} else if (!this.matchesUuid(envelopeUuid)) {
			this.setState({invalidUuid: true, invalidMessage: "Zarf numarası ETTN formatında olmalıdır."})
			return;
		}

		let formData = new FormData();

		formData.append("envelopeUuid", envelopeUuid);

		let params = {
			url: "/outbox/queryEnvelope",
			method: 'post',
			data: formData
		};

		this.setState({processing: true, result: null, code: null, invalidUuid: false, invalidMessage: ""});
		request(params).then(function (response) {
			self.setState({
				result: response.data.result,
				code: response.data.code,
				processing: false,
			});
		}).catch(function (error) {
			self.setState({processing: false});
			showAxiosError(error);
		});

	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.query();
		}
	}

	editHandleInputChange(event) {
		const target = event.target;
		const value = target.value;

		let envelopeUuid = value;
		this.setState({envelopeUuid});
	}

	render() {
		let inputClasses = "form-control"
		if (this.matchesUuid(this.state.envelopeUuid)) inputClasses += " is-valid";
		if (this.state.invalidUuid) inputClasses += " is-invalid";

		return (
			<Modal isOpen={this.state.modal} keyboard={true} size="md">
				<Notify ref={this.notify}/>
				<ModalHeader toggle={this.toggleModal}>Zarf Sorgulama</ModalHeader>
				<ModalBody>
					{this.state.processing &&
					<div className="row"><span className="pull-right">İşleniyor..</span></div>}
					<Form>
						<FormGroup row>
							<Label sm={4}>Zarf Numarası</Label>
							<Col sm={8}>
								<input type="text" className={inputClasses}
									   autoFocus
									   disabled={this.state.processing}
									   value={this.state.envelopeUuid}
									   onChange={this.editHandleInputChange}
									   onKeyPress={this.handleKeyPress}/>
								{
									this.state.invalidUuid &&
									<FormText className="text-danger">
										{this.state.invalidMessage}
									</FormText>
								}
							</Col>
						</FormGroup>
						{this.state.result &&
						<FormGroup>
							<Label sm={12}
								   style={this.state.code === 999 ? {color: "crimson"} : {color: "midnightblue"}}>
								{this.state.result}
							</Label>
						</FormGroup>
						}
					</Form>
				</ModalBody>
				<ModalFooter>
					<div className="col-sm-12 row">
						<div className="col-sm-3">
							<button type="button" onClick={this.reset}
									className=" TekBtn delete" style={{
								padding: '9PX 43PX 9PX 15PX',
								background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
							}}>Temİzle
							</button>
						</div>
						<div className="col-sm-6"></div>
						<div className="col-sm-3">
							<button type="button" onClick={this.query} className="  TekBtn kaydet "
									style={{padding: '9PX 43PX 9PX 15PX'}}>Sorgula
							</button>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		)
	}
}


export default QueryEnvelopeModal;



